import { TasksIcon, PM2QuoteIcon, PM2FactIcon } from '@ui/kit/icons';
import Ribbon from '../organism.content/atom.ribbon.js';
import { video23Printers } from './spec.23video.js';
import { factbox } from './spec.box.comp.style.js';
import { fontPrinters } from './spec.font.js';
import { iGuideHtmlNodeJsxPrinters } from './spec.html.js';
import { imagePrinters } from './spec.image.js';
import { linkPrinters } from './spec.link.js';
import { medialibraryPrinters } from './spec.medialibrary.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Box(props) {
  const icon = (() => {
    switch (props.node.boxType) {
      case "fact":
        return /*#__PURE__*/jsx(PM2FactIcon, {});
      case "quote":
        return /*#__PURE__*/jsx(PM2QuoteIcon, {});
      case "question":
        return /*#__PURE__*/jsx(TasksIcon, {});
    }
  })();
  return /*#__PURE__*/jsxs("span", {
    className: factbox,
    children: [/*#__PURE__*/jsx(Ribbon, {
      children: icon
    }), props.context.printChildren(props.node.children, {
      ...iGuideHtmlNodeJsxPrinters,
      ...imagePrinters,
      ...video23Printers,
      ...medialibraryPrinters,
      ...fontPrinters,
      ...linkPrinters
    })]
  });
}

export { Box as default };
//# sourceMappingURL=spec.box.comp.js.map
